import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function OurTokenomics() {
  return (
    <div className='OurTokenomics relative z-10 md:-mt-44 -mt-32 lg:h-[1375px] md:h-[1200px] h-[860px]  lg:gap-10 lg:px-20 md:px-10 px-4'>
      <div className='flex justify-center items-center md:pt-44 pt-32 flex-col gap-5'>
        <div className='absolute top-[10%] left-[0%]'>
          <img
            src='/images/bitcoin-gif.gif'
            alt='bitcoin-gif'
            className='lg:w-[480px] md:w-[250px] md:h-[280px] w-[130px] h-[130px] object-contain'
          />
        </div>
        <div className=''>
          <AnimateOnScroll animation='flipIn'>
            <img
              src='/images/OurTokenomics-img.png'
              alt='OurTokenomics-img'
              className='lg:w-[661px] md:w-[347px] lg:h-[279px] md:h-[150px] h-[100px] object-contain'
            />
          </AnimateOnScroll>
        </div>

        <div className='grid lg:grid-cols-4 grid-cols-2  gap-5'>
          <AnimateOnScroll animation='flipIn'>
            <div className='border-4 border-white rounded-2xl p-4 w-full text-center space-y-2'>
              <div className='bg-[#FF9E2D] py-1 text-center'>
                <h4 className='md:text-2xl text-sm'>NAME</h4>
              </div>
              <h4 className='md:text-2xl text-sm text-[#FF122F]'>
                Bitcoin Pizza
              </h4>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <div className='border-4 border-white rounded-2xl p-4 w-full text-center space-y-2'>
              <div className='bg-[#FF9E2D] py-1 text-center'>
                <h4 className='md:text-2xl text-sm'>SYMBOL</h4>
              </div>
              <h4 className='md:text-2xl text-sm text-[#FF122F]'>PIZZA</h4>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <div className='border-4 border-white rounded-2xl p-4 w-full text-center space-y-2'>
              <div className='bg-[#FF9E2D] py-1 text-center'>
                <h4 className='md:text-2xl text-sm'>SUPPLY</h4>
              </div>
              <h4 className='md:text-2xl text-sm text-[#FF122F]'>10 Billion</h4>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <div className='border-4 border-white rounded-2xl p-4 w-full text-center space-y-2'>
              <div className='bg-[#FF9E2D] py-1 text-center'>
                <h4 className='md:text-2xl text-sm'>TAXES</h4>
              </div>
              <h4 className='md:text-2xl text-sm text-[#FF122F]'>0%</h4>
            </div>
          </AnimateOnScroll>
        </div>
        <div className='up-down'>
          <AnimateOnScroll animation='flipIn'>
            <img
              src='/images/pizza-2.png'
              alt='pizza-2'
              className='lg:w-[643px] lg:h-[527px] md:w-[350px] md:h-[400px]   h-[200px] object-contain'
            />
          </AnimateOnScroll>
        </div>
      </div>
    </div>
  )
}
